/*eslint-disable*/

import React, { useState, useEffect } from 'react';
import { Button, Modal, Table } from 'semantic-ui-react';
import ReadAxios from '../axiosComponent/read'

const HistoryModal = (props) => {
    const { vehicle, vehicleNo } = props
    const [dochistory, setdochistory] = useState([])
    
    
    useEffect(() => {
        let vId = vehicle
        console.log("VID==>", vId)
        ReadAxios({ url: 'fleet/document/getDocumentHistory', readItems: { vehicleId: vId, vehicleNo: vehicleNo } })
            .then((response) => {
                setdochistory(response)
                console.log("DocHistory", response)
            });
    }, []) 
    
    
    const downloadFile = (doclink) => { 
        window.location.href = doclink
    }

    return (
        <Modal centered={false}
            open={props.modalOpen}
            onClose={props.handleClose}>
            <Modal.Header >
                <div style={{ color: "grey"}}>{vehicleNo} Documents History</div>
                {console.log("Vehicle NO Dashboard", vehicleNo)}
                <Modal.Actions>
                    <Button icon="delete" onClick={props.handleClose} basic style={{ position: "absolute", right: 20, top: 20 }} />
                </Modal.Actions>
            </Modal.Header>

            {
                dochistory.length !== 0 
                ? 
                (<Table fixed size="small" >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className="labelName p-bold-600">Document Type</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Start Date</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Expiry Date</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Updated On</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Download</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            dochistory.map(( object, index) => (
                                <>
                                    <Table.Row key={index}>
                                        <Table.Cell>{object.docTypeName}</Table.Cell>
                                        <Table.Cell>{object.startDate}</Table.Cell>
                                        <Table.Cell>{object.expiryDate}</Table.Cell>
                                        <Table.Cell>{object.updatedOn}</Table.Cell>
                                        <Table.Cell>{object.documentLink ? <Button onClick={() => downloadFile(object.documentLink)} icon="download" /> : "Not Available"}</Table.Cell>
                                    </Table.Row>
                                </>
                            ))
                        }
                    </Table.Body>                
                </Table>
                )
                :
                <div style={{ paddingLeft: 24, paddingTop: 20, paddingBottom: 20}}>No Record(s) Found</div>
            } 
            
            
        </Modal>
    )
}




export default HistoryModal